<template>
  <el-dialog :visible.sync="dialogVisible" :before-close="close" class="operate-dialog">
    <p slot="title" class="dialog-title">批量操作</p>
    <div class="operate-cards">
      <template v-if="operations.length">
        <div v-for="(item,index) in operations" :key="index" @click="goLotOperate(item.action)" :class="['shadow','set-background']"  :style="{backgroundImage: 'url(' + (item.background) + ')', backgroundSize:'80%'}">
        <span :class="['iconfont',item.icon]"></span>
        <p>{{item.name}}</p>
      </div>
      </template>
      <p v-else>您没有权限批量操作的权限</p>
    </div>
  </el-dialog>
</template>

<script>
import { hasPermissions } from 'utils/permissions'
// 组件class前缀
const prefixCls = 'pt-lot-operate-choice-dialog'

export default {
  name: 'pt-lot-operate-choice-dialog',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 关闭的回掉
    handleClose: {
      type: Function
    }
  },
  data () {
    return {
      visible: this.dialogVisible,
      operations: this.getHasPermisOpr([{
        name: '创建订单',
        icon: 'icon-chuangjiandingdan',
        background: require('@/assets/images/back-icon00.png'),
        action: 'CREATED',
        permisson: 'PERM_LAB_CREATE_ORDER'
      }, {
        name: '样本接收',
        icon: 'icon-yangbenjieshou',
        background: require('@/assets/images/back-icon01.png'),
        action: 'LAB_SAMPLES_RECEIVED',
        permisson: 'PERM_LAB_SAMPLE_RECEIVE'
      }, {
        name: '核酸提取',
        icon: 'icon-hesuantiqu',
        background: require('@/assets/images/back-icon02.png'),
        action: 'LAB_DNA_READY',
        permisson: 'PERM_LAB_DNA_READY'
      }, {
        name: '上机检测',
        icon: 'icon-shangjijiance',
        background: require('@/assets/images/back-icon03.png'),
        action: 'DATA_ANALYSISED',
        permisson: 'PERM_LAB_DATA_ANALYSISED'
      }, {
        name: '上传报告',
        icon: 'icon-shangchuanbaogao',
        background: require('@/assets/images/back-icon04.png'),
        action: 'REPORT_CHECKED_1ST',
        permisson: 'PERM_LAB_CHECKED_1ST'
      }])
    }
  },
  methods: {
    getHasPermisOpr (data) {
      let permissons = this.$auth.user().permissions
      let res = data.filter(item => {
        return hasPermissions(permissons, item.permisson)
      })
      return res
    },
    close (val) {
      this.handleClose && this.handleClose()
    },
    goLotOperate (url) {
      if (url === 'CREATED') {
        this.$router.push('/business-order-lot-new')
        return
      }
      this.$router.push({ name: 'lab-order-lot-operate', params: { status: url } })
    }
  }
}
</script>

<style  lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import '~less/var.less';
.operate-dialog{
  .el-dialog{
    border-radius: 10px;
    padding:30PX;
    width:28%;
    min-width: 800px;
  }
  .operate-cards{
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    .set-background{
      // width:200PX;
      padding:30PX 30PX;
      border-radius: 10px;
      background-position: bottom right;
      background-repeat: no-repeat;
      background-size: 80% 80%;
      cursor: pointer;
      p{
        color: @mainColor;//#e9c799;
        font-size:16PX;
        font-weight: bold;
        line-height: 20PX;
      }
      span{
        display: inline-block;
        width:48PX;
        height: 48PX;
        line-height: 48PX;
        border-radius: 50%;
        background: linear-gradient(to right, #eacda3 , #e6b980);
        color:#fff;
        font-size: 22px;
      }
    }
  }
  .dialog-title{
    font-weight: bold;
    font-size: 26PX;
    margin-top: 0;
    margin-bottom: 0;
    line-height: 0;
  }
}
</style>
